import React from 'react'

/** Rows shaped like UpcomingSingleContent, shown on a panel's first load. */
function ContentListSkeleton({ rows = 3 }) {
    return (
        <div aria-hidden="true">
            {Array.from({ length: rows }).map((_, index) => (
                <div key={index} className="bg-containerGray rounded-xl mb-4 p-3 mx-8">
                    <div className="flex flex-row items-center justify-between">
                        <div className="flex flex-row items-center gap-2">
                            <div className="dsh-skeleton-block w-[20px] h-[20px]" />
                            <div className="dsh-skeleton-block h-4 w-[90px]" />
                        </div>
                        <div className="dsh-skeleton-block h-4 w-[60px]" />
                    </div>
                    <div className="dsh-skeleton-block h-5 w-[60%] mt-4" />
                    <div className="dsh-skeleton-block h-4 w-[90%] mt-3" />
                    <div className="dsh-skeleton-block h-4 w-[70%] mt-2" />
                    <div className="flex flex-row items-center justify-between mt-4">
                        <div className="dsh-skeleton-block h-4 w-[120px]" />
                        <div className="dsh-skeleton-block h-4 w-[140px]" />
                    </div>
                </div>
            ))}
        </div>
    )
}

export default ContentListSkeleton
